export const __prod__ = process.env.REACT_APP_PRODUCTION === 'true';
export const TINYMCE_KEY = '1scccp68oytdhaoeqpt3b19mfe0z4xgxgdzs43pgqg1fcpha';
